import React from "react"
// MUI
import {Box, Checkbox, Typography} from "@mui/material";
// Tokens
import {packagingTokens as tk} from "@/theme/packagingTokens";

// Modern brand multi-picker (rows: initial avatar + name + checkbox), toggling
// ids in `app.brands_id`. Matches the AssociatedBrandsDialog list styling.
export default function BrandMultipleSelect(props: any) {

    const {app, setApp, brands, t} = props

    if (!brands || !app) return <></>

    const selected: string[] = app.brands_id ?? []

    const handleBrandSelection = (id: any) => {
        if (!id) return
        const next = selected.includes(id)
            ? selected.filter((b: string) => b !== id)
            : [...selected, id]
        setApp({...app, brands_id: next})
    }

    return (
        <Box>
            <Typography sx={{fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", color: tk.color.textTertiary, mb: 0.75}}>
                {t("associated_brands")}
            </Typography>
            <Box
                className={"fancyScroll"}
                sx={{maxHeight: 260, overflowY: "auto", border: `1px solid ${tk.color.borderLight}`, borderRadius: tk.radius.card}}
            >
                {brands.length === 0 ? (
                    <Typography sx={{fontSize: "13px", color: tk.color.textSecondary, textAlign: "center", py: 3}}>
                        {t("no_elements_found")}
                    </Typography>
                ) : brands.map((brand: any, i: number) => {
                    const isSelected = selected.includes(brand.id)
                    return (
                        <Box
                            key={brand.id}
                            onClick={() => handleBrandSelection(brand.id)}
                            sx={{
                                display: "flex", alignItems: "center", gap: 1.25,
                                px: 1.5, py: 0.875,
                                cursor: "pointer",
                                borderBottom: i < brands.length - 1 ? `1px solid ${tk.color.borderLight}` : "none",
                                backgroundColor: isSelected ? tk.color.green50 : "transparent",
                                transition: "background .15s ease",
                                "&:hover": {backgroundColor: isSelected ? tk.color.green100 : tk.color.bg},
                            }}
                        >
                            <Box
                                sx={(theme) => ({
                                    width: 26, height: 26, flexShrink: 0,
                                    borderRadius: tk.radius.sm,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: "12px", fontWeight: 700,
                                    color: isSelected ? theme.palette.primary.main : tk.color.textSecondary,
                                    backgroundColor: isSelected ? tk.color.green100 : tk.color.bg,
                                    border: `1px solid ${isSelected ? tk.color.green100 : tk.color.borderLight}`,
                                })}
                            >
                                {(brand.name ?? "?").charAt(0).toUpperCase()}
                            </Box>
                            <Typography sx={{flex: 1, fontSize: "13px", fontWeight: isSelected ? 600 : 500, color: tk.color.textPrimary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                                {brand.name}
                            </Typography>
                            <Checkbox
                                checked={isSelected}
                                size={"small"}
                                tabIndex={-1}
                                disableRipple
                                sx={{p: 0.25}}
                                inputProps={{"aria-label": brand.name}}
                            />
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}
